var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h2", { attrs: { tabindex: "-1" } }, [
      _vm._v("\n    " + _vm._s(_vm.$t("Expanded.Title_BasicInfo")) + "\n  ")
    ]),
    _vm._v(" "),
    _vm.basicInfo
      ? _c(
          "div",
          [
            _vm.isPlaceOpen
              ? _c("place-open-basic-info-view", {
                  attrs: {
                    basicInfo: _vm.basicInfo,
                    specification: _vm.specification
                  }
                })
              : _c(
                  "div",
                  [
                    _vm.basicInfo.operationName
                      ? _c("text-label-row", {
                          attrs: {
                            title: "Expanded.BasicInfo.OperationName",
                            value: _vm.basicInfo.operationName
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.basicInfo.purpose
                      ? _c("text-label-row", {
                          attrs: {
                            title: "Expanded.BasicInfo.Purpose",
                            value: _vm.basicInfo.purpose
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("location-control", {
                      attrs: {
                        location: _vm.basicInfo.location,
                        showChannels: !_vm.isAy
                      }
                    })
                  ],
                  1
                )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }